export default __webpack_public_path__ + "static/media/book.df14c09b.svg";